<template>
  <div>
    <v-navigation-drawer v-if="!isMobile" v-model="drawer" class="contact-scroll" fixed temporary right width="550" max-width="80%" style="z-index: 999;">
      <v-list-item>
        <ib-btn v-if="isMobile" icon large class="mr-1" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </ib-btn>
        <ib-user-avatar :user="contact" size="55" class="mr-4 my-4" />
        <v-list-item-content>
          <v-list-item-title><b>{{ contact.override_name || contact.name }}</b></v-list-item-title>
          <v-list-item-subtitle>
            <v-icon size="16">mdi-phone-outline</v-icon>
            {{ $utils.formatPhone(contact.phone) }}
          </v-list-item-subtitle>
        </v-list-item-content>
          <ib-btn small color="primary" @click="updateContact()">
            Salvar
          </ib-btn>
      </v-list-item>
      <v-divider class="semi_transparent" />
      <v-list dense>
        <v-list-item v-if="contact?.tags?.length" class="mb-2">
          <v-list-item-icon class="mb-2">
            <v-icon>mdi-tag-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="gray600--text">
            <v-list-item-title class="mb-2 subtitle-2 ">
              <b>Tags</b>
            </v-list-item-title>
            <v-list-item-title class="d-flex flex-wrap">
              <ib-chip v-for="(tag, index_tag) in contact?.tags" v-show="tags_dictionary[tag]" :key="`tag2_${index_tag}`" small class="mr-1 mt-1" :color="tags_dictionary[tag]?.color">
                {{ tags_dictionary[tag]?.name }}
              </ib-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="contact?.tags?.length" class="mx-4 semi_transparent" />
        <v-list-item class="mb-2 gray600--text">
          <v-list-item-icon class="mb-2">
            <v-icon>mdi-account-details-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="mb-2 subtitle-2">
              <b>Variáveis</b>
            </v-list-item-title>
            <v-list-item-title v-for="(item, index) in contact_data_vars" :key="`c_var_${index}`">
              <ib-btn class="mr-1 pa-1" icon small color="error lighten-2" height="100%" @click="selectedContactVar = { item, index }; deleteContactVarDialog = true">
                <v-icon size="18">
                  mdi-trash-can-outline
                </v-icon>
              </ib-btn>
              <ib-btn class="mr-1 pa-1" icon small height="100%" @click="selectedContactVar = { item: JSON.parse(JSON.stringify(item)), index: index }; createOrUpdateContactVarDialog = true;">
                <v-icon size="18" class="p-0">
                  mdi-pencil-outline
                </v-icon>
              </ib-btn>
              <b>{{ item.key }}:</b> {{ item.value }}
            </v-list-item-title>
            <v-row class="mt-1">
              <v-col cols="12">
                <ib-btn small color="primary" class="mr-4" outlined @click="selectedContactVar = { item: {}, index: null }; createOrUpdateContactVarDialog = true">
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  Nova variável
                </ib-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="contact_data_vars.length" class="mx-4 semi_transparent" />
        <v-list-item class="mb-2 gray600--text">
          <v-list-item-icon class="mb-2">
            <v-icon>mdi-note-edit-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="mb-2 subtitle-2">
              <b>Anotações</b>
            </v-list-item-title>
            <v-row>
              <v-col v-for="(item, index) in contact.annotations" :key="`annotations_${index}`" cols="12">
                <div v-if="item.user && item.created" class="small-text mb-1"><b>{{ item.user }}</b> - {{ $date.smallFormat(item.created) }}</div>
                <div class="d-flex">
                  <v-textarea v-model="contact.annotations[index].text" class="mt-2 nd-text-field" rows="4" :label="`Anotação ${index + 1}`" placeholder="Escreva aqui a anotação sobre esse contato ou atendimento efetuado." outlined hide-details="auto" />
                  <ib-btn icon color="error lighten-2" class="ml-2" @click="contact.annotations.splice(index, 1)">
                    <v-icon size="20">mdi-trash-can-outline</v-icon>
                  </ib-btn>
                </div>
              </v-col>
              <v-col cols="12">
                <ib-btn small class="mr-4" color="primary" outlined @click="contact.annotations.push({ user: currentUser.name, created: new Date(), text: '' })">
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  Nova anotação
                </ib-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Versão Mobile com V-Dialog ( o componente é igual ao acima, mas resolve bloqueios do teclado do iOS e touch do vuetify) -->
    <v-dialog v-else v-model="drawer" fullscreen hide-overlay transition="dialog-bottom-transition" style="z-index: 9999;">
      <div class="container-mobile contact-scroll">
        <v-list-item>
          <ib-btn v-if="isMobile" icon large class="mr-1" @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </ib-btn>
          <ib-user-avatar :user="contact" size="55" class="mr-4 my-4" />
          <v-list-item-content>
            <v-list-item-title><b>{{ contact.override_name || contact.name }}</b></v-list-item-title>
            <v-list-item-subtitle>
              <v-icon size="16">mdi-phone-outline</v-icon>
              {{ $utils.formatPhone(contact.phone) }}
            </v-list-item-subtitle>
          </v-list-item-content>
            <ib-btn small color="primary" @click="updateContact()">
              Salvar
            </ib-btn>
        </v-list-item>
        <v-divider class="mx-4 semi_transparent" />
        <v-list dense>
          <v-list-item v-if="contact?.tags?.length" class="mb-2">
            <v-list-item-icon class="mb-2">
              <v-icon>mdi-tag-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="gray600--text">
              <v-list-item-title class="mb-2 subtitle-2 ">
                <b>Tags</b>
              </v-list-item-title>
              <v-list-item-title class="d-flex flex-wrap">
                <ib-chip v-for="(tag, index_tag) in contact?.tags" v-show="tags_dictionary[tag]" :key="`tag2_${index_tag}`" small class="mr-1 mt-1" :color="tags_dictionary[tag]?.color">
                  {{ tags_dictionary[tag]?.name }}
                </ib-chip>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="contact?.tags?.length" class="mx-4 semi_transparent" />
          <v-list-item class="mb-2 gray600--text">
            <v-list-item-icon class="mb-2">
              <v-icon>mdi-account-details-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="mb-2 subtitle-2">
                <b>Variáveis</b>
              </v-list-item-title>
              <v-list-item-title v-for="(item, index) in contact_data_vars" :key="`c_var_${index}`">
                <ib-btn class="mr-1 pa-1" icon small color="error lighten-2" height="100%" @click="selectedContactVar = { item, index }; deleteContactVarDialog = true">
                  <v-icon size="18">
                    mdi-trash-can-outline
                  </v-icon>
                </ib-btn>
                <ib-btn class="mr-1 pa-1" icon small height="100%" @click="selectedContactVar = { item: JSON.parse(JSON.stringify(item)), index: index }; createOrUpdateContactVarDialog = true;">
                  <v-icon size="18" class="p-0">
                    mdi-pencil-outline
                  </v-icon>
                </ib-btn>
                <b>{{ item.key }}:</b> {{ item.value }}
              </v-list-item-title>
              <v-row class="mt-1">
                <v-col cols="12">
                  <ib-btn small color="primary" class="mr-4" outlined @click="selectedContactVar = { item: {}, index: null }; createOrUpdateContactVarDialog = true">
                    <v-icon left>
                      mdi-plus
                    </v-icon>
                    Nova variável
                  </ib-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="contact_data_vars.length" class="mx-4 semi_transparent" />
          <v-list-item class="mb-2 gray600--text">
            <v-list-item-icon class="mb-2">
              <v-icon>mdi-note-edit-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="mb-2 subtitle-2">
                <b>Anotações</b>
              </v-list-item-title>
              <v-row>
                <v-col v-for="(item, index) in contact.annotations" :key="`annotations_${index}`" cols="12">
                  <div v-if="item.user && item.created" class="small-text mb-1"><b>{{ item.user }}</b> - {{ $date.smallFormat(item.created) }}</div>
                  <div class="d-flex">
                    <v-textarea v-model="contact.annotations[index].text" class="mt-2 nd-text-field" rows="4" :label="`Anotação ${index + 1}`" placeholder="Escreva aqui a anotação sobre esse contato ou atendimento efetuado." outlined hide-details="auto" />
                    <ib-btn icon color="error lighten-2" class="ml-2" @click="contact.annotations.splice(index, 1)">
                      <v-icon size="20">mdi-trash-can-outline</v-icon>
                    </ib-btn>
                  </div>
                </v-col>
                <v-col cols="12">
                  <ib-btn small class="mr-4" color="primary" outlined @click="contact.annotations.push({ user: currentUser.name, created: new Date(), text: '' })">
                    <v-icon left>
                      mdi-plus
                    </v-icon>
                    Nova anotação
                  </ib-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-dialog>

    <ib-dialog v-model="createOrUpdateContactVarDialog" overlay-opacity="0.5" overlay-color="black" max-width="500" persistent style="z-index: 10000;">
      <v-card>
        <ib-dialog-header title="Variável do contato" :subtitle="selectedContactVar.index !== null ? 'Editar variável do contato' : 'Adicionar nova variável ao contato'" :close="() => createOrUpdateContactVarDialog = false" />
        <v-card-text>
          <ib-text-field v-model="selectedContactVar.item.key" label="Nome da variável" placeholder="nome" outlined hide-details="auto" @keyup.enter="createOrUpdateContactVar()" />
          <ib-text-field v-model="displaySelectedContactVarValue" class="mt-6" label="Valor da variável" placeholder="João" outlined hide-details="auto" @keyup.enter="createOrUpdateContactVar()" />
        </v-card-text>
        <v-card-actions>
          <ib-btn outlined color="error" @click="createOrUpdateContactVarDialog = false">
            Cancelar
          </ib-btn>
          <v-spacer />
          <ib-btn dark color="primary" @click="createOrUpdateContactVar()">
            {{selectedContactVar.index !== null ? 'Editar' : 'Adicionar'}}
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>

    <ib-dialog v-model="deleteContactVarDialog" overlay-opacity="0.5" overlay-color="black" max-width="450" persistent style="z-index: 10000;">
      <v-card>
        <ib-dialog-header title="Deletar variável" :close="() => deleteContactVarDialog = false" />
        <v-card-text>
          <p class="body-2">Tem certeza que deseja excluir a variável <b>{{ selectedContactVar.item.key }}</b> do contato?</p>
        </v-card-text>
        <v-card-actions>
          <ib-btn outlined color="error" @click="deleteContactVarDialog = false">
            Cancelar
          </ib-btn>
          <v-spacer />
          <ib-btn dark color="primary" @click="deleteContactVar()">
            Excluir
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>
  </div>
</template>

<script>
import Api from '@/lib/Api';
import { emitToastr } from "@/lib/Utils";

export default {
  props: {
    value: Boolean,
    contact_id: String,
    tags_dictionary: Object
  },
  data() {
    return {
      loading: false,
      contact: {},
      contact_data_vars: [],
      createOrUpdateContactVarDialog: false,
      deleteContactVarDialog: false,
      selectedContactVar: { item: {}, index: null },
      displaySelectedContactVarValue: '',
      preventDrawerClose: false
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    currentUser() {
      return this.$store.state.currentUser
    },

    isAnyDialogOpen() {
      return this.createOrUpdateContactVarDialog || this.deleteContactVarDialog;
    },

    drawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(val) {
      if (!val && this.preventDrawerClose) {
        this.$nextTick(() => {
          this.$emit('input', true);
        });
      }
    },
    isAnyDialogOpen(val) {
      if (val) {
        this.preventDrawerClose = true;
      } else {
        setTimeout(() => { this.preventDrawerClose = false; }, 300);
      }
    },
    drawer: {
      async handler() {
        if (this.drawer && this.contact_id && !this.preventDrawerClose) {
          this.loading = true;
          const resp = await Api.getContactById(this.contact_id);
          this.loading = false;

          if (!resp.error && resp.message) {
            this.contact = resp.message;
            this.contact_data_vars = [];

            if (this.contact.data && Object.keys(this.contact.data).length > 0) {
              this.contact_data_vars = Object.keys(this.contact.data).map(item => ({ key: item, value: this.contact.data[item] }));
            }

            if (this.contact.annotations?.length) {
              this.contact.annotations.forEach((a, index) => {
                if (typeof (a) === 'string') {
                  this.contact.annotations[index] = { text: a };
                }
              })
            }
          }
        }
      },
      deep: false,
    },
    'selectedContactVar.item.value': {
      immediate: true,
      handler(val) {
        this.displaySelectedContactVarValue = typeof val === 'object' ? JSON.stringify(val, null, 2) : val;
      }
    }
  },
  methods: {
    async updateContact() {
      const contact_data_formatted = this.contact_data_vars.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {});
      this.contact.data = contact_data_formatted;
      
      this.loading = true;
      const resp = await Api.changeContactAnnotationsAndData(this.contact);
      this.loading = false;
      if (!resp.error) emitToastr("success", "Contato atualizado");
    },
    createOrUpdateContactVar() {
      if (!this.selectedContactVar.item.key || !this.displaySelectedContactVarValue) {
        emitToastr("error", "Preencha todos os campos");
        return
      }

      let value = this.displaySelectedContactVarValue;
      try {
        value = JSON.parse(value);
      } catch (e) {
        // Mantém como string se não for um JSON
      }

      const newItem = { key: this.selectedContactVar.item.key, value };

      const existingIndex = this.contact_data_vars.findIndex((item, i) => item.key === newItem.key && i !== this.selectedContactVar.index);

      if (existingIndex !== -1) {
        emitToastr("error", "Essa variável já existe para o contato.");
        return;
      }

      if (this.selectedContactVar.index === null) this.contact_data_vars.push(newItem) 
      else this.contact_data_vars[this.selectedContactVar.index] = newItem;

      this.displaySelectedContactVarValue = null;
      this.selectedContactVar = { item: {}, index: null }
      this.createOrUpdateContactVarDialog = false;
    },
    deleteContactVar(){      
      this.contact_data_vars.splice(this.selectedContactVar.index, 1);
      this.selectedContactVar = { item: {}, index: null }
      this.deleteContactVarDialog = false;
    }
  }
};
</script>

<style>
.semi_transparent {
  opacity: 0.5;
}

.small-text {
  font-size: 12px;
}

.contact-scroll,
.contact-scroll .v-navigation-drawer__content {
  scrollbar-width: thin !important;
  scrollbar-color: rgba(206, 206, 206, 0.322) transparent !important;
}

.contact-scroll,
.contact-scroll .v-navigation-drawer__content,
.contact-scroll textarea {
  -webkit-overflow-scrolling: touch;
}

.contact-scroll::-webkit-scrollbar,
.contact-scroll .v-navigation-drawer__content::-webkit-scrollbar,
.contact-scroll textarea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contact-scroll::-webkit-scrollbar-track,
.contact-scroll .v-navigation-drawer__content::-webkit-scrollbar-track,
.contact-scroll textarea::-webkit-scrollbar-track {
  background: transparent;
}

.contact-scroll::-webkit-scrollbar-thumb,
.contact-scroll .v-navigation-drawer__content::-webkit-scrollbar-thumb,
.contact-scroll textarea::-webkit-scrollbar-thumb {
  background-color: rgba(206, 206, 206, 0.55);
  border-radius: 999px;
}

.contact-scroll::-webkit-scrollbar-thumb:hover,
.contact-scroll .v-navigation-drawer__content::-webkit-scrollbar-thumb:hover,
.contact-scroll textarea::-webkit-scrollbar-thumb:hover {
  background-color: rgba(160, 160, 160, 0.75);
}

.container-mobile {
  background-color: var(--v-gray50-base) !important;
  height: 100%;
  overflow-y: auto;
}
</style>